import { Component, ElementRef, QueryList, ViewChildren } from "@angular/core";
import { PopoverConfig, PopoverRef } from "@tylertech/forge-angular";

export interface ContextMenuItem
{
    readonly value: string;
    readonly label: string;
    onClick($event: Event): void;
}

export interface ContextMenuData
{
    readonly items: ReadonlyArray<ContextMenuItem>;
}

@Component({
    selector: "app-menu-context-menu",
    templateUrl: "./contextmenu.tmpl.html",
    standalone: false
})
export class ContextMenuComponent
{
    protected currentIndex = 0;

    @ViewChildren("item") readonly menuItemElements: QueryList<ElementRef<HTMLButtonElement>>;

    constructor(
        private readonly popoverRef: PopoverRef,
        private readonly config: PopoverConfig<ContextMenuData>)
    { }

    private get anchorElement(): HTMLElement { return this.popoverRef.nativeElement.anchorElement as HTMLElement; }
    get contextItems(): ReadonlyArray<ContextMenuItem> { return this.config.data.items; }

    onClick($event: Event, item: ContextMenuItem): void
    {
        item.onClick($event);
    }

    onKeyUp($event: KeyboardEvent): void
    {
        const focusableCount = this.menuItemElements.length;
        const key = $event.key;

        if (key === "Tab")
        {
            $event.preventDefault();

            this.anchorElement.focus();
            this.popoverRef.close();
            return;
        }

        if (key === "ArrowUp")
        {
            this.currentIndex--;
            if (this.currentIndex < 0)
            {
                this.currentIndex = focusableCount - 1;
            }
        }

        if (key === "ArrowDown")
        {
            this.currentIndex++;
            if (this.currentIndex > focusableCount - 1)
            {
                this.currentIndex = 0;
            }
        }

        this.menuItemElements.get(this.currentIndex).nativeElement.focus();
    }
}
